import { useState, useEffect } from "react";

const DEFAULT_TIMEOUT = 30000; // ms

export default function useIdle(timeout = DEFAULT_TIMEOUT) {
  const [idle, setIdle] = useState(() => document.hidden);

  useEffect(() => {
    let timer;
    const reset = () => {
      clearTimeout(timer);
      setIdle(document.hidden);
      if (!document.hidden) timer = setTimeout(() => setIdle(true), timeout);
    };
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];
    events.forEach((e) => window.addEventListener(e, reset));
    window.addEventListener("focus", reset);
    document.addEventListener("visibilitychange", reset);
    reset();
    return () => {
      events.forEach((e) => window.removeEventListener(e, reset));
      window.removeEventListener("focus", reset);
      document.removeEventListener("visibilitychange", reset);
      clearTimeout(timer);
    };
  }, [timeout]);

  return idle;
}
